module.exports = __webpack_public_path__ + "static/media/participantsIcon.5691e0ec.svg";